<template>
	<div>
		
		
		<h3>fdsafdsa</h3>
		<el-form ref="form" :model="form" label-width="80px">
			
			<div style="margin-bottom: 3rem;">
				<div class="bt_hs1" style="margin-bottom: 15px;">请选择需要咨询的类别</div>
				<el-radio-group v-model="form.resource">
					<div style="margin-bottom: 1rem;"> 
					<el-radio label="劳动纠纷"></el-radio>
					</div>
					<el-radio label="政策详讯"></el-radio>
				</el-radio-group>
			</div>
			
			<div style="margin-bottom: 1.875rem;">
				<div class="bt_hs1">请输入您的具体问题</div>
				<el-input type="textarea" v-model="form.desc"  :rows="4"></el-input>
			</div>
			
			<div style="margin-bottom: 1.875rem;">
				<div class="bt_hs1">姓名</div>
				<el-input v-model="form.name"></el-input>
			</div>
			
			<div style="margin-bottom: 1.875rem;">
				<div class="bt_hs1">电话</div>
				<el-input v-model="form.name"></el-input>
			</div>
			
			<el-form-item>
				<el-button type="primary" @click="onSubmit">提交资料</el-button>
				<el-button>取消</el-button>
			</el-form-item>
			
		</el-form>
	
	
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				}
			}
		},
		methods: {
			onSubmit() {
				console.log('submit!');
			}
		}
	}
</script>

<style scoped>
	.bt_hs1{
		font-size: 16px; 
		margin-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/views/jjgh/add_users_a.vue